import {Component, inject, Injectable, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";

import {I18nService, ProjectService} from "@wms/services";
import {PreferenceService} from "@wms/services";
import {EventManagerService} from "@wms/app";

@Injectable()
export class BaseComponent implements OnDestroy {
  public registerDestroyListener = new Subscription();
  locale: any;
  preferences: any;
  operationsList: Array<any> = [];
  // root: any;
  views: ViewMap = {
    container: {},
    dialog: [],
    all: {},
    containerIdNameMap: {}
  }

  public i18nService: I18nService;
  public preferencesService: PreferenceService;
  public projectService: ProjectService;
  public eventManager: EventManagerService;
  public leftPanelMoreActionsDD: boolean;
  public headerExportDD: boolean;
  public headerSettingsDD: boolean;
  public headerDeviceBuildDD: boolean;
  public headerDeployDD: boolean;
  public headerVCSDD: boolean;
  public headerRecentWSDD: boolean;
  public headerRunDD: boolean;
  public studioRefreshQueue;

  constructor() {
    this.i18nService = inject(I18nService);
    this.preferencesService = inject(PreferenceService);
    this.projectService = inject(ProjectService);
    this.locale = this.i18nService.getMessages();
    this.preferences = this.preferencesService.get();
    this.eventManager = inject(EventManagerService);
    // TODO: To be replaced with root service
    // this.root = {};
    // this.root.preferences = this.preferences = this.preferencesService.get();
    // this.root.selectedViewPort = {
    //   category: 'Web',
    //   id: 'laptop_mdpi',
    //   name: 'Laptop with MDPI Screen',
    //   labelKey: 'LABEL_DEVICE_LAPTOP_WITH_MDPI_SCREEN',
    //   width: '1280',
    //   height: '800',
    //   default: true
    // };
    // this.root.project = {
    //   platformType: 'DEFAULT'
    // };
    // this.root.isPrefabType = false;
    // this.root.isMobileApplicationType = false;
    // this.root.isNativeMobileApplicationType = false;
    this.views.dialog = [];
    this.studioRefreshQueue = this.eventManager.consumeStudioRefreshQueue();
  }

  processStudioRefreshQueue(): void {
    let studioRefreshQueueDeletedIndices: any[] = [];
    this.studioRefreshQueue.forEach((data, i) => {
      if (data !== null) {
        let isRefreshDone = this.refreshStudio(data);
        if(isRefreshDone) {
          studioRefreshQueueDeletedIndices.push(i);
        }
      }
    });
    this.cleanupStudioRefreshQueue(studioRefreshQueueDeletedIndices);
  }

  cleanupStudioRefreshQueue(studioRefreshQueueDeletedIndices: any[]): void {
    // Remove later (backwards so indices don’t shift)
    for (let i of studioRefreshQueueDeletedIndices.reverse()) {
      this.studioRefreshQueue.splice(i, 1);
    }
  }

  refreshStudio(changeSet: any): boolean {
    //implement this in all the workspaces to refresh the studio
    return false;
  }

  ngOnDestroy() {
    this.registerDestroyListener.unsubscribe();
  }

  dispatchSafeEvent(eventType: string, detail: any) {
    const event = new CustomEvent(eventType, { detail });
    const win = window as any;

    if (
      win.__agenticChatEvents?.listenersReady?.[eventType]
    ) {
      win.dispatchEvent(event);
    } else {
      win.__agenticChatEvents = win.__agenticChatEvents || {
        listenersReady: {},
        eventQueues: {},
      };
      win.__agenticChatEvents.eventQueues[eventType] =
        win.__agenticChatEvents.eventQueues[eventType] || [];
      win.__agenticChatEvents.eventQueues[eventType].push(event);
    }
  }
}

export interface DialogInfo {
  name: string | undefined;
  widgetId: string | undefined;
  parentWidgetId: string | undefined;
  displayName: string | '';
  iconClass: string | '';
}

export interface ViewMap {
  container: {[key: string]: Array<any>},
  dialog: Array<DialogInfo>,
  all: {[key: string]: DialogInfo},
  containerIdNameMap: {[key: string]: string}
}
